import { type ReactElement } from 'react';

import { ChipGroup } from '@spotify-internal/encore-web';
import { Box } from '@spotify-internal/encore-web/next';

import { InlineFilterTrigger } from './InlineFilterTrigger';
import { type FilterDefinition, useFilters } from './provider';

export const QuickFilters = ({
  filters: filtersOverride,
}: { filters?: FilterDefinition[] } = {}): ReactElement | null => {
  const { filters, quickFilterIds } = useFilters();
  const definitions = filtersOverride ?? filters;
  const quickFilters = quickFilterIds.flatMap(id => {
    const filter = definitions.find(definition => definition.id === id);
    return filter ? [filter] : [];
  });
  if (!quickFilters.length) return null;

  return (
    <Box minWidth="min-content" flexGrow={1} flexBasis="0">
      <ChipGroup mode="action" layout="multi-line" aria-label="Quick filters">
        {quickFilters.map(filter => (
          <InlineFilterTrigger key={filter.id} filter={filter} />
        ))}
      </ChipGroup>
    </Box>
  );
};
